module.exports = new __parcel__URL__("issue-permissions-dialog-actions-skeleton.tpl.4c3ffc65.svg").toString();